import {Endpoint, MakeRequest, RestResponse} from './request'
import type {
  AdvertiseHash,
  AppStorage,
  ComplainAdvertisePayload,
  ComplainAdvertiseRequestDTO,
  ComplainReasonModel,
} from '../index'
import type {Secure} from '../helpers/userSecure'

export class ComplainApi {
  constructor(
    private request: MakeRequest,
    private storage: AppStorage,
    private secure: Secure,
  ) {}

  fetchReasons = (
    adHash: AdvertiseHash,
  ): Promise<RestResponse<Array<ComplainReasonModel>>> => {
    const hash = this.storage.userHash!
    const secure = this.secure.createUserSecure()
    return this.request.request<
      Array<ComplainReasonModel>,
      ComplainAdvertiseRequestDTO
    >({
      api: Endpoint.complainAdvertise,
      body: {
        hash_ad: adHash,
        get_list: true,
        hash,
        secur: secure,
      },
      method: 'POST',
    })
  }

  complain = async (payload: ComplainAdvertisePayload) => {
    try {
      const hash = this.storage.userHash!
      const secure = this.secure.createUserSecure()
      await this.request.request<any, ComplainAdvertiseRequestDTO>({
        api: Endpoint.complainAdvertise,
        method: 'POST',
        body: {...payload, hash, secur: secure},
      })
    } catch (e) {
      console.log('restToggleSubscribePrice error => ', e)
    }
  }
}
